<template>
    <div>
        <p v-if="isMobile" class="nav-menu nav-mobile"
            :class="{ 'nav-mobile--selected': isCurrentPage }"
            v-html="$t('NAV_BUTTON_LABEL', { 'button.label': $t(`${button.label}`)})"></p>

        <li v-else
            class="nav-link" :class="{ 'active-link': isSelected || isCurrentPage}" :style="customStyles">
            <a
                v-if="button.route === 'faq.categories'"
                :href="countryUtils.zendesk_hc_url"
                class="nav-link">
                {{ $t('TOP_NAVIGATION_HELP') }}
            </a>
            <router-link v-else :to="{name: button.route}" v-html="$t('NAV_BUTTON_LABEL', { 'button.label': $t(`${button.label}`)})"></router-link>
            <div class="underline"></div>
        </li>
    </div>
</template>
<script>
import countryUtils from '@/resources/countryUtils.json';

export default {
    name: 'NavButton',
    props: {
        button: {
            required: true,
            default: {},
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        customStyles: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            isSelected: false,
            countryUtils: countryUtils.filter(item => item.locale.toLowerCase() === process.env.VUE_APP_DATE_LOCALE.toLowerCase())[0],
        };
    },
    mounted() {
        this.isSelected = this.$route.name === this.button.route;
    },
    computed: {
        isCurrentPage() {
            return this.$route.name === this.button.route;
        },
    },
    watch: {
        '$route'(to) {
            this.isSelected = to.name === this.button.route;
        },
    },
};
</script>

<style lang="scss" scoped>
    .nav-menu {
        font-family: 'Gill Sans';
        font-style: normal;
        font-weight: 300;
        font-size: 20px;
        line-height: 24px;
    }

    .nav-mobile {
        text-decoration: none;
        &--selected {
            border-radius: 136px;
            padding: 8px;
            padding-left: 16px;
            padding-right: 16px;
            background-color: #ECE9E8;
            text-decoration: none;
        }
    }

    li {
        list-style-type: none;
        font-size: 24px;
    }

    li .underline {
        height: 3px;
        background-color: transparent;
        width: 0%;
        transition: width 0.2s, background-color 0.5s;
        -moz-transition: width 0.2s, background-color 0.5s;
        -webkit-transition: width 0.2s, background-color 0.5s;
        margin: 0 auto;
        border-radius: 24px;
    }

    li.active-link .underline {
        width: 100%;
        background-color: #C2D1A7;
    }

    li:hover .underline {
        background-color: #ECE9E8;
        width: 100%;
    }
</style>
